module.exports = __webpack_public_path__ + "img/toggleextrakeys.1081d92f.svg";